import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ProductViewHelperService } from './../../services/product-view-helper.service';
import { LoaderService } from '../../../app/services/loader.service';
declare var $: any;

@Component({
    selector: 'save-alert',
    styleUrls: ['./save-alert.style.scss'],
    templateUrl: './save-alert.template.html',
    standalone: false
})
export class SaveAlert implements  AfterViewInit {
  private lastActiveElement: HTMLElement | null = null;

  @ViewChild('closeAlertModalBtn') closeAlertModalBtn: ElementRef;
  @Input() public isScompActivity: boolean = false;

  constructor(
    private productViewHelperService : ProductViewHelperService,
    private loaderService : LoaderService
  ) {}

  ngAfterViewInit() {
    $('#saveAlertModal').on('show.bs.modal', () => {
      this.lastActiveElement = <HTMLElement>document.activeElement;
    });

    $('#saveAlertModal').on('shown.bs.modal', () => {
      this.closeAlertModalBtn.nativeElement.focus();
      this.closeAlertModalBtn.nativeElement.classList.add('focus-visible');
    });

    $('#saveAlertModal').on('hidden.bs.modal', () => {
      this.lastActiveElement?.focus();
    });
  }

  saveAlertActionSelection(val: boolean) {
    if(!val) {
      this.loaderService.hideLoader();
    }
    this.productViewHelperService.saveAlertAction.next(val);
  }

}